// extracted by mini-css-extract-plugin
export var container = "video-module--container--R9Ylh";
export var video = "video-module--video--13PIv";
export var cover = "video-module--cover--1id3y";
export var claimWrap = "video-module--claimWrap--2IIfn";